export enum Colors {
    salmon = "#eb7e77",
    sage = "#829e9f",
    darkSage = "#526969",
    lightSage = "#b0c4c4",
    beige = "#ecd7cb",
    blue = "#3a7a7a",
    lightBlue = "#9cc6c6",
    backgroundBlue = "#d1e2e2",
    backgroundBeige = "rgb(229 229 229 / var(--tw-bg-opacity, 1))",
    white = "#ffffff",
    moleyDarkGreen = "rgb(63 124 124 / var(--tw-bg-opacity, 1))",
}